export const MAXIMUM_USER_COUNT = 100;
export const NEW_TRIAL_STRING = 'NEW_TRIAL_SIGNUP';

export const generateNewTrialString = () => `${NEW_TRIAL_STRING}_${Date.now()}`;
